import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const insertB2BPackageQuotation = createAsyncThunk(
  "B2BPackageQuotation/InsertB2BPackageQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BPackageQuotation/InsertB2BPackageQuotation`,
        formData
      );
      SuccessToast(response.data?.Details || "B2B Package Quotation Created Successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to create B2B package quotation");
      console.error("Error creating B2B package quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createB2BQuotation = createAsyncThunk(
  "B2BQuotation/InsertB2BQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BQuotation/InsertB2BQuotation`,
        formData
      );
      SuccessToast(response.data?.Details || "B2B Quotation Created Successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to create B2B quotation");
      console.error("Error creating B2B quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateB2BQuotation = createAsyncThunk(
  "B2BQuotation/UpdateB2BQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BQuotation/UpdateB2BQuotation`,
        formData
      );
      SuccessToast(response.data?.Details || "B2B Quotation Updated Successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to update B2B quotation");
      console.error("Error updating B2B quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getB2BQuotationByID = createAsyncThunk(
  "B2BQuotation/FindByIDB2BQuotation",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BQuotation/FindByIDB2BQuotation`,
        { ID }
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to fetch B2B quotation");
      console.error("Error fetching B2B quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// ✅ New APIs matching the requested endpoints

export const findAllB2BQuotation = createAsyncThunk(
  "B2BPackageQuotation/FindALLB2BQuotation",
  async (params: any) => {
    try {
      const payload = {
        filterLeadID: params?.filterLeadID || 0,
        filterInquiryID: params?.filterInquiryID || 0,
        filterName: params?.filterName || "",
        filterMobileNo: params?.filterMobileNo || "",
        filterEmailID: params?.filterEmailID || "",
        filterQuotationNo: params?.filterQuotationNo || "",
        Limit: params?.limit || params?.Limit || 50,
        Skip: params?.skip || params?.Skip || 0,
      };
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BPackageQuotation/FindALLB2BQuotation`,
        payload
      );
      return response.data?.Data || [];
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to fetch B2B quotations");
      console.error("Error fetching B2B quotations:", error);
      return Promise.reject(error);
    }
  }
);

export const updateB2BPackageQuotation = createAsyncThunk(
  "B2BPackageQuotation/UpdateB2BPackageQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BPackageQuotation/UpdateB2BPackageQuotation`,
        { ...formData, ID: formData.QuotationID || formData.ID || 0 }
      );
      SuccessToast(response.data?.Details || "B2B Package Quotation Updated Successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to update B2B package quotation");
      return Promise.reject(error);
    }
  }
);

export const deleteB2BPackageQuotation = createAsyncThunk(
  "B2BPackageQuotation/DeleteB2BCustomQuotaion",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BPackageQuotation/DeleteB2BCustomQuotaion`,
        { ID }
      );
      SuccessToast(response.data?.Details || "B2B Package Quotation Deleted Successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to delete B2B package quotation");
      return Promise.reject(error);
    }
  }
);

export const findByB2BCustomQuotation = createAsyncThunk(
  "B2BPackageQuotation/FindByB2BCustomQuotaion",
  async (QuotationID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BPackageQuotation/FindByB2BCustomQuotaion`,
        { QuotationID }
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to fetch B2B quotation details");
      return Promise.reject(error);
    }
  }
);

export const findB2BQuotationHistory = createAsyncThunk(
  "B2BPackageQuotation/FindB2BQuotationHistory",
  async (ParentID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BPackageQuotation/FindB2BQuotationHistory`,
        { ParentID }
      );
      return response.data?.Data || [];
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to fetch B2B quotation history");
      return Promise.reject(error);
    }
  }
);

export const downloadB2BQuotation = createAsyncThunk(
  "B2BPackageQuotation/B2BQuotationDownload",
  async (QuotationID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BPackageQuotation/B2BQuotationDownload`,
        { QuotationID },
        { responseType: "blob" }
      );
      return response.data;
    } catch (error: any) {
      ErrorToast("Failed to download! - Please try again later");
      return Promise.reject(error);
    }
  }
);

